import { AgGridReact } from 'ag-grid-react';
import { useMemo } from 'react';

import { mockMaterials } from 'external-quote/constants';
import { IPartBom } from 'partBoms/types';

import { getColumnDefs } from './columns';
import { TableContainer } from './styles';

interface IProps {
  partBoms: IPartBom[];
}

const transformPartBomToMaterial = (partBom: IPartBom, index: number) => {
  return {
    line: index + 1,
    availLocQty: 0,
    quantity: 1,
    partType: 'BOM',
    custLine: index + 1,
    mfrPartNumber: partBom.number || '---',
    mfgBrand: partBom.manufacturerName || 'Wesco',
    supplierPoNumber: '---',
    description: partBom.descriptionLong || '---',
    customerPartNumber: '---',
    io: 'IO',
    dateCode: '---',
    shipType: 'Delivery By',
    partBomId: partBom.id,
  };
};

interface IMaterialsTableProps extends IProps {
  onBomButtonClick?: (partBomId: number) => void;
}

export const MaterialsTable = ({ partBoms, onBomButtonClick }: IMaterialsTableProps) => {
  const columnDefs = useMemo(() => getColumnDefs(onBomButtonClick), [onBomButtonClick]);

  const rowData = useMemo(() => {
    const transformedPartBoms = partBoms.map((partBom, index) =>
      transformPartBomToMaterial(partBom, mockMaterials.length + index)
    );

    return [...mockMaterials, ...transformedPartBoms];
  }, [partBoms]);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
      filter: true,
    }),
    []
  );

  return (
    <TableContainer>
      <div className="ag-theme-quartz" style={{ height: '100%', width: '100%' }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          animateRows={true}
          enableCellTextSelection={true}
          ensureDomOrder={true}
        />
      </div>
    </TableContainer>
  );
};
